import { Component, OnInit } from '@angular/core';
import { BaseLoginComponent } from 'src/app/shared/components/base-login/base-login.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-doctors-station-login',
  templateUrl: './doctors-station-login.component.html',
  styleUrls: ['../style/global.css', './doctors-station-login.component.css'],
})
export class DoctorsStationLoginComponent
  extends BaseLoginComponent
  implements OnInit
{
  async init(): Promise<void> {}

  get isMedicalUser() {
    return this.role !== 'patient';
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId].type);
  }

  get isShowHeader() {
    // oemの場合はヘッダーを非表示にする
    if (this.isOem) return false;
    // dstationConfigが設定されている場合はその設定に従う
    if (this.app?.dstationConfig?.isHideLoginPageComponent?.header)
      return false;
    return true;
  }

  get isShowPageLinks() {
    // dstationConfigが設定されている場合はその設定に従う
    if (this.app?.dstationConfig?.isHideLoginPageComponent?.pageLinks)
      return false;
    return true;
  }

  get isRegisterResendable(): boolean {
    // EAJの場合は確認メール再送信させない
    if (environment.apps[this.clientId].oemConfig?.id === 'EAJ') return false;

    return true;
  }

  get isRegistable() {
    // 医療ユーザーがログインしようとしている場合は新規会員登録させない
    if (this.isMedicalUser) return false;

    // 自治体向けOEMの場合も新規会員登録させない
    if (this.isOem) return false;

    // dstationConfigが設定されている場合はその設定に従う
    if (this.app?.dstationConfig?.isHideLoginPageComponent?.registerButton)
      return false;

    return true;
  }

  get logoUrl() {
    return (
      this.app?.oemConfig?.imgpath || '/assets/doctors-station/images/logo.svg'
    );
  }
}
